import { Divider } from "antd";

import { formatCurrency } from "../../utils/currency";
import styles from "./styles.module.scss";

interface ReviewPaymentDetailsProps {
  couponCode: string;
  discountAmount: number;
  discountStatus: "success" | "error" | "";
  earlyApplicationAmount: number;
  isApplyingDiscount: boolean;
  isLateApplication: boolean;
  lateApplicationFee: number;
  originalTotalAmount: number;
  shouldPayLateApplicationFee: boolean;
  totalAmount: number;
  onApplyDiscount: () => void;
  onCouponCodeChange: (couponCode: string) => void;
}

const ReviewPaymentDetails = ({
  couponCode,
  discountAmount,
  discountStatus,
  earlyApplicationAmount,
  isApplyingDiscount,
  isLateApplication,
  lateApplicationFee,
  originalTotalAmount,
  shouldPayLateApplicationFee,
  totalAmount,
  onApplyDiscount,
  onCouponCodeChange,
}: ReviewPaymentDetailsProps) => {
  return (
    <div className={styles.payment}>
      <h3>Payment Details</h3>
      {isLateApplication ? null : (
        <section>
          <div className={styles.discount}>
            <div className={styles.paymentInput}>
              <input
                value={couponCode}
                onChange={(event) => onCouponCodeChange(event.target.value)}
                placeholder="Enter Coupon Code"
              />
            </div>
            <button
              onClick={onApplyDiscount}
              disabled={!couponCode || isApplyingDiscount}
            >
              {isApplyingDiscount ? "Applying..." : "Apply"}
            </button>
          </div>
          {discountStatus && (
            <small
              style={{
                color: discountStatus === "success" ? "green" : "red",
              }}
            >
              {discountStatus === "success" ? "Discount applied" : "Invalid code"}
            </small>
          )}
        </section>
      )}
      <section className={styles.breakdown}>
        <div className={styles.breakdownItem}>
          <h6>Application Fee</h6>
          <p>{formatCurrency(earlyApplicationAmount)}</p>
        </div>
        {shouldPayLateApplicationFee && (
          <div className={styles.breakdownItem}>
            <h6>Late Application Fee</h6>
            <p>{formatCurrency(lateApplicationFee)}</p>
          </div>
        )}
        {discountAmount > 0 && (
          <div className={styles.breakdownItem}>
            <h6>Discount</h6>
            <p>- {formatCurrency(discountAmount)}</p>
          </div>
        )}
        <Divider />
        <div className={styles.breakdownItem}>
          <h6>Total</h6>
          <p>
            {discountAmount > 0 && <s>{formatCurrency(originalTotalAmount)}</s>}
            &nbsp; {formatCurrency(totalAmount)}
          </p>
        </div>
        <Divider />
      </section>
    </div>
  );
};

export default ReviewPaymentDetails;
